import { render, staticRenderFns } from "./PrintingActivityPage.vue?vue&type=template&id=3b86f912&scoped=true&lang=pug&"
import script from "./PrintingActivityPage.vue?vue&type=script&lang=ts&"
export * from "./PrintingActivityPage.vue?vue&type=script&lang=ts&"
import style0 from "./PrintingActivityPage.vue?vue&type=style&index=0&id=3b86f912&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b86f912",
  null
  
)

export default component.exports